import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  message: '',
  isVisible: false,
  duration: 3000,
};

const errorSnackSlice = createSlice({
  name: 'errorSnack',
  initialState,
  reducers: {
    showError: (state, action) => {
      state.message = action.payload.message;
      state.isVisible = true;
      state.duration = action.payload.duration || 3000;
    },
    hideError: (state) => {
      state.message = '';
      state.isVisible = false;
    },
  },
});

export const { showError, hideError } = errorSnackSlice.actions;

export const selectErrorSnack = (state) => state.errorSnack;

export default errorSnackSlice.reducer;
